import React from "react";
import { Button, Modal, ModalTitle, ModalActions, Typography } from "@platform-ui/design-system";

interface DiscardChangesModalProps {
    open: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

export const DiscardChangesModal = ({ open, onConfirm, onClose }: DiscardChangesModalProps) => {
    return (
        <Modal
            maxWidth="sm"
            fullWidth
            open={open}
            id="discard-unsaved-changes"
            dsOnClose={onClose}
            header={<ModalTitle dsOnClose={onClose} body="Discard Unsaved Changes" />}
            body={
                <Typography variant="body1" body="Are you sure you want to discard your changes? All changes will be lost." />
            }
            footer={
                <ModalActions>
                    <Button
                        variant="outlined"
                        dsOnClick={onClose}
                        body="Cancel"
                    />
                    <Button
                        dsOnClick={onConfirm}
                        body="Discard Changes"
                    />
                </ModalActions>
            }
        />
    );
};

